
export function setSignupHeight() {
    // Get the element with the class .marquee-button
    const marqueeButton = document.querySelector('.sign-up-area');
    
    if (marqueeButton) {
      // Get the height of the element
      const height = marqueeButton.offsetHeight;
      
      // Set the height as a root CSS variable
      document.documentElement.style.setProperty('--sign-up-area-height', `${height}px`);
    }
  }